import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment-timezone";
import HighchartsCustomEvents from "highcharts-custom-events";
import { numberWithCommas, mFormatter, kmFormatter } from "../../../../../Dashboard/Charts/utils";
import ResizeObserver from "resize-observer-polyfill";

HighchartsCustomEvents(Highcharts);

function EngagementOverTimeChart(props) {
    const chartComponent = useRef();
    const legendAlign = props.isIGPage ? "right" : "center";
    useEffect(() => {
        let ro = null;
        // if (!props.isIGPage) {
        ro = new ResizeObserver(() => {
            chartComponent?.current?.chart?.setSize(null, null);
            chartComponent?.current?.chart?.reflow();
        });
        if (props.widgetContainerRef?.current) {
            ro.observe(props.widgetContainerRef?.current);
        }
        // }
        return () => {
            // if (!props.isIGPage) {
            ro.disconnect();
            // }
        };
    }, []);

    const getChartOptions = () => {
        let tzo = JSON.parse(localStorage.company).user_timezone * -60;
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        const data = JSON.parse(JSON.stringify(props.chartData || {}));
        let seriesName = props.isLKPage || (props.chartName === "engagement_rate_over_time" && props.isIGPage) ? "Engagement Rate" : "Engagement";

        let series = [{ color: "#72cc50", name: seriesName, data: data?.total_agg ? data.total_agg : [] }];

        const chartOptions = {
            chart: {
                type: props.graphType === "line" ? "spline" : "column",
                backgroundColor: "transparent",
                style: {
                    fontFamily: "'Roboto', sans-serif",
                    fontSize: 12,
                },
            },
            credits: {
                enabled: false,
            },
            lang: {
                noData: "No data.",
            },
            noData: {
                style: {
                    fontWeight: "bold",
                    fontSize: "15px",
                    color: "#303030",
                },
                position: {
                    align: "center",
                },
            },
            title: {
                text: " ",
            },
            xAxis: {
                lineColor: "#ccd6eb",
                lineWidth: 1,
                type: "datetime",
                dateTimeLabelFormats: {
                    millisecond: "%l:%M:%S.%L %p",
                    second: "%l:%M:%S %p",
                    minute: "%l:%M %p",
                    hour: "%l:%M %p",
                    day: "%e %b",
                    week: "%e. %b",
                    month: "%b '%y",
                    year: "%Y",
                },
                labels: {
                    style: {
                        textTransform: "normal",
                    },
                },
            },
            yAxis: {
                gridLineWidth: props.showGridLines ? 2 : 0,

                gridLineDashStyle: "ShortDash",
                gridLineColor: "#ccd6eb",
                lineColor: "#ccd6eb",
                lineWidth: 1,
                allowDecimals: false,
                title: {
                    text: ``,
                },
                plotLines: props.showAverage
                    ? [
                          {
                              color: "#8e95a4", // Color value
                              value: data?.avg_value, // Value of where the line will appear
                              width: 2, // Width of the line
                              dashStyle: "solid",
                              zIndex: 6,
                              label: {
                                  align: "right",
                                  text: `Average : ${data?.avg_value}`,
                                  x: 0,
                                  style: {
                                      color: "#8e95a4",
                                      fontWeight: "bold",
                                  },
                              },
                          },
                      ]
                    : [],
            },
            series,
            legend: {
                enabled: props.showLegend,
                align: legendAlign,
                itemStyle: {
                    fontWeight: 500,
                    fontFamily: "'Roboto', sans-serif",
                    textTransform: "normal",
                },
                alignColumns: false,
            },

            plotOptions: {},
            tooltip: {
                formatter: function () {
                    return `${props.GMTTimeZone ? moment(this.x).format("LLLL") : moment(this.x).tz(tz).format("LLLL")}<br/>${
                        this.series.name
                    }: <b>${numberWithCommas(this.y)}</b>`;
                },

                backgroundColor: "#fff",
                borderRadius: 6,
            },
            time: {
                timezoneOffset: tzo,
            },
        };

        return chartOptions;
    };

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={getChartOptions()}
            ref={chartComponent}
            containerProps={{ style: { width: "100%", height: "100%" } }}
        />
    );
}

export default EngagementOverTimeChart;
